import { toExcel, type IGridColumn } from './toExcel';
// import { Plate } from '../types/plate';
// import axios from '../api/axiosSetup3';

// export const getExportData = async (): Promise<Plate[]> => {
//     const customer_id = import.meta.env.VITE_CUSTOMER_ID;
//     const res = await axios.get<Plate[]>('/lpr_plate');
//     return res.data;
// };

export interface IDataRow {
    [key: string]: string | number | boolean | null | undefined;
  }

export const dataToExcel = async <T extends Record<string, any>>(
    // data: IDataRow[],
    data: T[],
    excelFilename: string = 'export_data'    
): Promise<void> => {
    console.log(`Starting data export to Excel for ${excelFilename}`);
    try {
        // Проверяем, есть ли данные и хотя бы одна строка
        if (data && data.length > 0) {
            console.log(`Fetched ${data.length} rows. Generating columns and exporting to Excel...`);

            // Получаем первую строку для определения колонок
            const firstRow = data[0];
            // Генерируем массив IGridColumn из ключей первого объекта
            const generatedColumns: IGridColumn[] = Object.keys(firstRow).map(key => ({
                key: key, // Используем ключ объекта как key для доступа к данным
                name: key, // Используем ключ объекта как name для заголовка колонки
                // Можно добавить width или другие свойства по умолчанию, если нужно
                // width: 20,
            }));

            // Вызываем toExcel с сгенерированными колонками, данными и именем файла
            await toExcel(generatedColumns, data, excelFilename);

            console.log(`Successfully exported data to ${excelFilename}.xlsx`);
        } else {
            console.log(`No data found for export. Excel file not generated.`);
            // Можно добавить уведомление пользователю
        }
    } catch (error) {
        console.error(`Error exporting data to Excel:`, error);
        // Обработка ошибки (например, показать уведомление)
    }        
}
/**
 * Fetches data from a specified table and exports it to an Excel file.
 * Column definitions for Excel are automatically generated from the keys of the first data row.
 *
 * @param tableName The name of the table to fetch data from.
 * @param excelFilename Optional: The desired name for the output Excel file (without extension). Defaults to the table name.
 * @param fields Optional: Specific fields to fetch. Defaults to '*'.
 * @param where Optional: Conditions for fetching data using IWhereClause.
 * @param order Optional: Sorting order for the data.
 */

// Пример использования остается прежним, но теперь не нужно передавать колонки вручную
/*
import React from 'react';
import { Button } from '@mui/material';
import { dataToExcel } from './api/tools/dataToExcel'; // Уточните путь

const MyComponent = () => {

    const handleExport = async () => {
        // Пример: Экспорт всех данных из 'users'
        await dataToExcel('users', 'all_users_export');

        // Пример: Экспорт активных продуктов с сортировкой
        // await dataToExcel(
        //     'products',
        //     'active_products',
        //     'product_id, name, price', // Указываем нужные поля
        //     { is_active: true },
        //     'price DESC'
        // );
    };

    return (
        <Button variant="contained" onClick={handleExport}>
            Export Data to Excel
        </Button>
    );
}

export default MyComponent;
*/
